import React from 'react';
import { Container } from '@realm-kf/halcyon-components-react';
import styles from './journeyBuilder.css';
export var AB_IFRAME_ID = 'jrniIframe';
export var AB_IFRAME_RESIZER_SCRIPT = 'https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/4.1.1/iframeResizer.min.js';
var runIFrameResize = function () {
    iFrameResize({
        log: false,
        checkOrigin: false,
        enablePublicMethods: true,
        heightCalculationMethod: 'lowestElement',
    }, "#".concat(AB_IFRAME_ID));
};
var JourneyBuilder = function (_a) {
    var url = _a.url;
    React.useEffect(function () {
        // @ts-ignore
        if (typeof window.iFrameResize === 'function') {
            runIFrameResize();
        }
        else {
            var script = document.createElement('script');
            script.src = AB_IFRAME_RESIZER_SCRIPT;
            script.onload = function () { return runIFrameResize(); };
            document.body.appendChild(script);
        }
    });
    return (React.createElement(Container, null,
        React.createElement("iframe", { id: AB_IFRAME_ID, className: styles.iFrame, src: url, title: "Appointment Booking", allow: "fullscreen; geolocation", sandbox: "allow-scripts allow-same-origin allow-forms allow-popups" })));
};
export { JourneyBuilder };
